import { metadataTagZonesColorArray } from "../../EditIMetadataTagZones/EditMetadataTagZonesUtils/metadataTagZonesColorArray";

export const getNextAssignmentColor = (usedColors: string[]): string => {
  for (const color of metadataTagZonesColorArray) {
    if (!usedColors.includes(color)) {
      return color;
    }
  }
  return metadataTagZonesColorArray[
    usedColors.length % metadataTagZonesColorArray.length
  ];
};
